// import { Box, Typography, IconButton, Select, MenuItem, useTheme } from "@mui/material";
// import { useContext, useEffect, useState } from "react";
// import { ColorModeContext } from "../theme/theme";
// import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
// import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
// import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
// import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import { useTranslation } from "react-i18next";

// const Topbar = ({ onToggleNav }) => {
//   const theme = useTheme();
//   const colorMode = useContext(ColorModeContext);
//   const { t, i18n } = useTranslation();
//   const [userID, setUserID] = useState(null);

//   useEffect(() => {
//     const retrievedUserID = localStorage.getItem("userID");
//     if (retrievedUserID) {
//       setUserID(retrievedUserID);
//     }
//   }, []);

//   return (

//     <AppBar position="fixed" sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}>
//       <Toolbar>
//         <IconButton color="inherit" edge="start" onClick={onToggleNav} sx={{ mr: 2 }}>
//           <MenuIcon />
//         </IconButton>
//         <Box
//           display="flex"
//           alignItems="center"
//           justifyContent="space-between"
//           p={0.8}
//           boxShadow={0.8}
//           bgcolor={theme.palette.background.default}
//           sx={{
//             flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
//             gap: 1,
//             px: { xs: 1, sm: 2 },
//           }}
//         >
//           {/* Left Section - Language Selector */}
//           <Select
//             value={i18n.language}
//             size="small"
//             onChange={(event) => i18n.changeLanguage(event.target.value)}
//             sx={{
//               minWidth: 80,
//               '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
//               fontSize: "12px",  // Adjusts the selected value's font size
//             }}
//           >
//             <MenuItem value="en" sx={{ fontSize: "14px" }}>English</MenuItem>  {/* Adjusted MenuItem font size */}
//             <MenuItem value="hi" sx={{ fontSize: "14px" }}>हिंदी</MenuItem>    {/* Adjusted MenuItem font size */}
//             <MenuItem value="ta" sx={{ fontSize: "14px" }}>தமிழ்</MenuItem>  {/* Adjusted MenuItem font size */}
//           </Select>


//           {/* Center Section - Title */}

//           <Typography variant="h4" fontWeight="bold" >
//             <IconButton >
//               <img
//                 alt="profile-user"
//                 width="30px"
//                 height="30px"
//                 src={`../Assets/images/OptrimLogo1.png`}
//                 style={{ cursor: "pointer", borderRadius: "20%" }}
//               />
//             </IconButton>
//             Business Process App
//           </Typography>



//           {/* Right Section - Icons & User */}
//           <Box display="flex" alignItems="center">
//             <IconButton onClick={colorMode.toggleColorMode}>
//               {theme.palette.mode === "dark" ? <DarkModeOutlinedIcon sx={{ fontSize: "16px" }} /> : <LightModeOutlinedIcon sx={{ fontSize: "16px" }} />}
//             </IconButton>
//             <IconButton>
//               <NotificationsOutlinedIcon sx={{ fontSize: "16px" }} />  {/* Reduced icon size */}
//             </IconButton>
//             <IconButton>
//               <SettingsOutlinedIcon sx={{ fontSize: "16px" }} />  {/* Reduced icon size */}
//             </IconButton>
//             <IconButton>
//               <PersonOutlinedIcon sx={{ fontSize: "16px" }} />  {/* Reduced icon size */}
//             </IconButton>

//             {/* User ID Display */}
//             {userID && (
//               <Typography variant="body2" sx={{ ml: 1, fontWeight: "bold", fontSize: "12px" }}>  {/* Reduced font size */}
//                 {userID}
//               </Typography>
//             )}
//           </Box>


//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Topbar;

// import { AppBar, Toolbar, IconButton, Typography } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';

// const TopBar = ({ onToggleNav }) => (
//   <AppBar position="fixed" sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}>
//     <Toolbar>
//       {/* <IconButton color="inherit" edge="start" onClick={onToggleNav} sx={{ mr: 2 }}>
//           <MenuIcon />
//         </IconButton>
//         <Typography variant="h6" sx={{ flexGrow: 1 }}>
//           Business Process App
//         </Typography>
//         <IconButton color="inherit">
//           <AccountCircleIcon />
//         </IconButton> */}
//     </Toolbar>
//   </AppBar>
// );

// export default TopBar;


import { AppBar, Toolbar, Box, Typography, IconButton, Select, MenuItem, useTheme, Divider, Badge, colors, } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ColorModeContext } from "../theme/theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";

const Topbar = ({ onToggleNav }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const colorMode = useContext(ColorModeContext);
  const { t, i18n } = useTranslation();
  const [userID, setUserID] = useState(null);

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [notification, setNotification] = useState(0);

  useEffect(() => {
    const retrievedUserID = localStorage.getItem("userID");
    if (retrievedUserID) {
      setUserID(retrievedUserID);
    }
  }, []);



  useEffect(() => {
    if (!isDataLoaded) {
      fetchAmentApprovalRequest();
    }
  }, [isDataLoaded]);

  const fetchAmentApprovalRequest = async () => {
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      P_plantid: 1,
      p_user: localStorage.getItem('userID'),
      p_id_approved_by: localStorage.getItem('employeeID'),
      p_mode: 0,
    }

    callApi(API_ENDPOINTS.VIEW_ALL_REQUEST_APPROVAL_FOR_AMENT_PROCESS_BY_EMPLOYEE_ID, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          setNotification(data.length);
        }
        else {
          setNotification(0);
        }
      })
      .catch(error => {
        alert(error.message);
      });

  }

  return (
    <AppBar position="fixed"
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        height: 50,
        justifyContent: "center",
        // bgcolor: theme.palette.background.default,#161d26
        bgcolor: "#161d26",
        borderRadius: 0,
      })}>
      <Toolbar sx={{ justifyContent: "space-between", px: 1, minHeight: 48, height: 48 }}>

        {/* Left: Menu Toggle + Language */}
        <Box display="flex" alignItems="center" gap={2}>
          {/* <IconButton color="inherit" edge="start" onClick={onToggleNav}>
            <MenuIcon />
          </IconButton> */}
          {/* <img
              alt="logo"
              src="../assets/images/papyrus3602.png"
              width={90}
              height={40}
              // style={{ borderRadius: "20%" }}
            /> */}

          <Box display="flex" alignItems="center">
            <img
              alt="logo"
              src="../assets/images/papyrus3602.png"
              width={90}
              height={40}
            // style={{ borderRadius: "20%" }}
            />


            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            {/* <Typography variant="h2" fontWeight="bold" ml={0.5} sx={{ color: colors.red[400] }} noWrap>
              BPApp
            </Typography> */}
            <img
              alt="logo"
              src="../assets/images/transparent_bp_app.png"
              width={100}
              height={40}
              // style={{ borderRadius: "20%" }}
            />
            {/* <Typography variant="h4" sx={{color:colors.red[400]}} fontWeight="bold" ml={0.5} noWrap>
              Business Process App
            </Typography> */}

          </Box>
        </Box>

        {/* Right: Actions + UserID */}
        <Box display="flex" alignItems="center" gap={1}>
          <Select
            value={i18n.language}
            size="small"
            onChange={(event) => i18n.changeLanguage(event.target.value)}
            sx={{
              minWidth: 80,
              color: "white",
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              fontSize: "12px",  // Adjusts the selected value's font size
            }}
          >
            <MenuItem value="en" sx={{ fontSize: "14px" }}>English</MenuItem>  {/* Adjusted MenuItem font size */}
            <MenuItem value="hi" sx={{ fontSize: "14px" }}>हिंदी</MenuItem>    {/* Adjusted MenuItem font size */}
            <MenuItem value="es" sx={{ fontSize: "14px" }}>தமிழ்</MenuItem>  {/* Adjusted MenuItem font size */}
          </Select>

          <IconButton onClick={colorMode.toggleColorMode} sx={{ color: "white" }}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlinedIcon fontSize="small" />
            ) : (
              <LightModeOutlinedIcon fontSize="small" />
            )}
          </IconButton>
          <IconButton sx={{ color: "white" }}>
            <NotificationsOutlinedIcon fontSize="small" />
          </IconButton>
          <IconButton sx={{ color: "white" }}>
            <SettingsOutlinedIcon fontSize="small" />
          </IconButton>
          {/* user icons */}
          <IconButton sx={{ color: "white" }} onClick={() => navigate("/all-notifications")}>
            <Badge badgeContent={notification}
              color="error"
              overlap="circular"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "10px",
                  height: "16px",
                  minWidth: "16px",
                  padding: "0 4px",
                }
              }} >
              <PersonOutlinedIcon fontSize="small" />
            </Badge>
          </IconButton>

          {userID && (
            <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "12px", color:"white"}}>
              {userID}
            </Typography>
          )}
        </Box>
      </Toolbar>
      {/* <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 40,
          right: 40,
          height: "5px",
          bgcolor: "#00796b",
        }}
      /> */}
    </AppBar>
  );
};

export default Topbar;

